/**
 * Gộp GET đang chạy; không TTL, không ảnh hưởng các lệnh ghi/xác nhận.
 * 261029 P1: một GET chỉ được gộp vào lượt đang bay nếu KHÔNG có lệnh ghi nào hoàn tất từ lúc lượt đó bắt đầu (`writeEpoch`) — nếu không, lượt tải lại SAU thao tác ghi có thể
 * nhận dữ liệu của GET bắt đầu TRƯỚC ghi. `markWorkflowWrite()` do `client.ts` gọi khi một lệnh ghi (post/put/patch/delete/upload) kết thúc, thành công hay lỗi.
 */
const pending = new Map<string, { promise: Promise<unknown>; epoch: number; generation: number }>();
let writeEpoch = 0;
/**
 * 261029 P3 (Reviewer F2): «thế hệ đọc». Đổi plan / làm mới toàn trang gọi `retireWorkflowReads()` ⇒ mọi GET ĐANG BAY coi như thuộc thế hệ cũ: lời gọi MỚI cùng khoá KHÔNG ghép vào đó mà bắn request mới
 * (người đã gọi trước khi reset vẫn nhận kết quả của họ). Độc lập với `writeEpoch` (ghi xong vẫn tách y như cũ).
 */
let readGeneration = 0;
export const workflowReadGeneration = (): number => readGeneration;
export const retireWorkflowReads = (): void => { readGeneration += 1; };
export const markWorkflowWrite = (): void => { writeEpoch += 1; };
/** Số lệnh ghi đã hoàn tất của tab này. Chỗ giao một lần (`workflowReadHandoff.ts`) gắn nó vào mỗi lượt đọc sớm để không bao giờ giao kết quả cũ hơn một lần ghi. */
export const workflowWriteEpoch = (): number => writeEpoch;
export function coalesceWorkflowGet<T>(key: string, fetch: () => Promise<T>): Promise<T> {
  let entry = pending.get(key);
  if (!entry || entry.epoch !== writeEpoch || entry.generation !== readGeneration) {
    const promise = Promise.resolve().then(fetch);
    const created = { promise: promise as Promise<unknown>, epoch: writeEpoch, generation: readGeneration };
    pending.set(key, created);
    const clear = () => { if (pending.get(key) === created) pending.delete(key); };
    promise.then(clear, clear);
    entry = created;
  }
  return (entry.promise as Promise<T>).then(value => typeof structuredClone === 'function' ? structuredClone(value) : JSON.parse(JSON.stringify(value)));
}
